import React, { Component } from "react";
import { List, Icon, Checkbox, Button } from "semantic-ui-react";

const styles = {
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  iconAndName: {
    display: "flex",
    alignItems: "center",
  },
  nameAndInfo: {
    display: "flex",
    flexDirection: "column",
  },
  info: {
    color: "rgba(0,0,0,.4)",
  },
};

class EntityUserItem extends Component {
  state = {
    checked: false,
  };

  componentDidMount() {
    this.setState({
      checked: this.props.item.activo === 1 ? true : false,
    });
  }

  render() {
    // console.log(this.props.item);
    return (
      <List.Item className="listItemPadding">
        <List.Content verticalAlign="middle">
          <div style={styles.listItem}>
            <div style={styles.iconAndName}>
              <Icon size="big" color="teal" name="hospital" />
              <div style={styles.nameAndInfo}>
                <a
                // onClick={() => {
                //   this.props.selectedEntity(this.props.item);
                //   this.props.showEditEntityForm();
                // }}
                >
                  {this.props.item.nombres} {this.props.item.apellidos}
                </a>
                <span style={styles.info}>
                  Usuario: {this.props.item.login}
                </span>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <Checkbox
                className="alignEnable"
                toggle
                name={this.props.item.login}
                onChange={this.props.handleApproveEntityUser}
                checked={this.props.item.activo === 1 ? true : false}
                floated="right"
              />
              <Button
                className="alignDelete"
                icon="trash"
                color="red"
                onClick={() => {
                  this.props.handleDeleteEntityUser(this.props.item.login);
                }}
              ></Button>
            </div>
          </div>
        </List.Content>
      </List.Item>
    );
  }
}

export default EntityUserItem;
